/**
 * Сторис для главной — `GET /stories`; открытие отмечается
 * `POST /stories/{id}/view`. Mock в браузере (`env.storiesMock`) — только для
 * показа без бэкенда.
 */
import { useQuery } from '@tanstack/react-query'
import type { ApiClient } from '@dorixona/api'
import {
  createHttpStoriesBackend,
  createMockStoriesStore,
  type StoriesBackend,
} from '@dorixona/api/stories'
import { useApi } from '../../api/context'
import { keys } from '../../api/keys'
import { env } from '../../config/env'
import { toStories, type Story } from './model'
import { nowMs } from '@dorixona/utils'

/**
 * Источник сторис: mock в браузере или настоящие ручки. Mock берёт свои часы
 * сам — это те же системные часы, что и `nowMs()` приложения.
 */
export function storiesBackend(api: ApiClient): StoriesBackend {
  return env.storiesMock
    ? createMockStoriesStore({ storage: localStorage, now: nowMs })
    : createHttpStoriesBackend(api)
}

export async function fetchPublishedStories(api: ApiClient): Promise<Story[]> {
  return toStories(await storiesBackend(api).published(), env.apiBaseUrl)
}

/** Витрина сторис в серверном порядке. */
export function usePublishedStories() {
  const api = useApi()
  return useQuery({
    queryKey: keys.stories,
    queryFn: () => fetchPublishedStories(api),
  })
}
